import { Circle, Eye, Pencil, CheckCircle, BadgeCheck } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { SupplierUXStatus } from '@/lib/api'

const STATUS_CONFIG: Record<SupplierUXStatus, {
  dot: string
  label: string
  icon: React.ReactNode
  container: string
}> = {
  not_opened: {
    dot: 'bg-gray-400',
    label: 'Non ouvert',
    icon: <Circle className="h-3 w-3" />,
    container: 'text-gray-600 bg-gray-100',
  },
  opened: {
    dot: 'bg-blue-500',
    label: 'Ouvert',
    icon: <Eye className="h-3 w-3" />,
    container: 'text-blue-700 bg-blue-100',
  },
  in_progress: {
    dot: 'bg-amber-500',
    label: 'En cours',
    icon: <Pencil className="h-3 w-3" />,
    container: 'text-amber-700 bg-amber-100',
  },
  submitted: {
    dot: 'bg-green-500',
    label: 'Soumis',
    icon: <CheckCircle className="h-3 w-3" />,
    container: 'text-green-700 bg-green-100',
  },
  validated: {
    dot: 'bg-green-800',
    label: 'Validé',
    icon: <BadgeCheck className="h-3 w-3" />,
    container: 'text-green-900 bg-green-200',
  },
}

export function SupplierStatusBadge({ status }: { status: SupplierUXStatus }) {
  const config = STATUS_CONFIG[status]
  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
      config.container
    )}>
      <span className={cn('h-1.5 w-1.5 rounded-full', config.dot)} />
      {config.label}
      {config.icon}
    </span>
  )
}
